/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiDoctorsPortalMessagesSortOrder =
    (typeof GetApiDoctorsPortalMessagesSortOrder)[keyof typeof GetApiDoctorsPortalMessagesSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiDoctorsPortalMessagesSortOrder = {
    asc: 'asc',
    desc: 'desc',
} as const;
